/**
 * Formatting utilities for regulations and IBC fields
 */

// Helper function to format USCG Group presentation
export const formatUSCGGroup = (uscgGroup: any): string => {
    if (!uscgGroup) return '';
    return `${uscgGroup.number} - ${uscgGroup.name}`;
};

// Helper function to format IMDG Class presentation
export const formatIMDGClass = (imdgClass: any): string => {
    if (!imdgClass) return '';
    return `${imdgClass.classification} - ${imdgClass.description}`;
};

// Helper function to map allowance enum to string
export const formatAllowance = (allowance: number | null | undefined): string => {
    if (allowance === null || allowance === undefined) return '';
    const allowanceMap: { [key: number]: string } = {
        0: 'Not Listed',
        1: 'Listed',
        2: 'Banned',
    };
    return allowanceMap[allowance] || '';
};

// Helper function to map NIOP allowance to string
export const formatNIOPAllowance = (allowance: number | null | undefined): string => {
    if (allowance === null || allowance === undefined) return '';
    const allowanceMap: { [key: number]: string } = {
        0: 'Not Listed',
        1: 'Listed',
        2: 'Restricted',
    };
    return allowanceMap[allowance] || '';
};

// Helper function to format boolean as Yes/No
export const formatYesNo = (value: boolean | null | undefined): string => {
    if (value === null || value === undefined) return '';
    return value ? 'Yes' : 'No';
};

// Re-export formatDate from centralized dateFormatters for backward compatibility
export { formatDate } from './dateFormatters';

// Helper function to format Marpol regulation enum
export const formatMarpolRegulation = (reg: number | null | undefined): string => {
    if (reg === null || reg === undefined) return '';
    const regMap: { [key: number]: string } = {
        0: 'None',
        1: 'Annex I',
        2: 'Annex II - Chapter 17',
        3: 'Annex III',
    };
    return regMap[reg] || '';
};

// Helper function to format Marpol pollution category
export const formatPollutionCategory = (category: number | null | undefined): string => {
    if (category === null || category === undefined) return '';
    const categoryMap: { [key: number]: string } = {
        0: 'None',
        1: 'X',
        2: 'Y',
        3: 'Z',
    };
    return categoryMap[category] || '';
};

// Helper function to format IBC enums (placeholder mappings)
export const formatIBCHazards = (hazards: number | null | undefined): string => {
    if (hazards === null || hazards === undefined) return '';
    // TODO: Needs actual enum mapping
    return hazards.toString();
};

export const formatShipType = (shipType: number | null | undefined): string => {
    if (shipType === null || shipType === undefined) return '';
    // TODO: Needs actual enum mapping
    return shipType.toString();
};

export const formatTankType = (tankType: number | null | undefined): string => {
    if (tankType === null || tankType === undefined) return '';
    // TODO: Needs actual enum mapping
    return tankType.toString();
};

export const formatTankVents = (vents: number | null | undefined): string => {
    if (vents === null || vents === undefined) return '';
    // TODO: Needs actual enum mapping
    return vents.toString();
};

export const formatEnvironmentalControl = (control: number | null | undefined): string => {
    if (control === null || control === undefined) return '';
    // TODO: Needs actual enum mapping
    return control.toString();
};

export const formatGauging = (gauging: number | null | undefined): string => {
    if (gauging === null || gauging === undefined) return '';
    // TODO: Needs actual enum mapping
    return gauging.toString();
};

export const formatVapourDetection = (detection: number | null | undefined): string => {
    if (detection === null || detection === undefined) return '';
    // TODO: Needs actual enum mapping
    return detection.toString();
};

export const formatFireProtection = (protectionArray: number[] | null | undefined): string => {
    if (!protectionArray || protectionArray.length === 0) return '';
    const protectionMap: { [key: number]: string } = {
        1: 'A',
        2: 'B',
        3: 'C',
        4: 'D',
        5: 'No',
    };
    return protectionArray.map(p => protectionMap[p] || p.toString()).join(', ');
};
